var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomViews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 310,
    height: 90,
    viewBox: "0 0 310 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.302,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25556e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eee",
    stopOpacity: 0.302
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: -0.629,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbb1d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454",
    transform: "translate(-990 -348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1884",
    "data-name": "Rectangle 1884",
    width: 100,
    height: 90,
    rx: 3,
    transform: "translate(990 335)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_16",
    "data-name": "Subtraction 16",
    d: "M28.5,57A28.508,28.508,0,0,1,17.408,2.24,28.489,28.489,0,0,1,57,28.5a28.747,28.747,0,0,1-.687,6.253L28.5,28.5l9.99,26.7A28.392,28.392,0,0,1,28.5,57Z",
    transform: "translate(1009.874 349.29)",
    fill: "#b3cea6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_12",
    "data-name": "Intersection 12",
    d: "M0,0,28.052,6.308A28.8,28.8,0,0,1,10.076,26.931Z",
    transform: "translate(1042.074 383.779)",
    fill: "#65a844"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449",
    transform: "translate(0 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1885",
    "data-name": "Rectangle 1885",
    width: 100,
    height: 90,
    rx: 3,
    transform: "translate(1095 335)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M421.346,750.362c0-4.792,5.768-16,13.145-15.775s7.773,24.286,17.268,23.917,11.567-8.258,18.689-8.141,12.91,11.351,18.146,11.067,10.4-10.942,13.2-15.826,9.552-7.227,9.552-7.227V789.54h-90Z",
    transform: "translate(678.654 -374.467)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450",
    transform: "translate(0 14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1886",
    "data-name": "Rectangle 1886",
    width: 100,
    height: 90,
    rx: 3,
    transform: "translate(1200 334)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1887",
    "data-name": "Rectangle 1887",
    width: 30,
    height: 10,
    rx: 5,
    transform: "translate(1218 348)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1888",
    "data-name": "Rectangle 1888",
    width: 43,
    height: 10,
    rx: 5,
    transform: "translate(1233 361)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1893",
    "data-name": "Rectangle 1893",
    width: 58,
    height: 10,
    rx: 5,
    transform: "translate(1218 400)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1889",
    "data-name": "Rectangle 1889",
    width: 35,
    height: 10,
    rx: 5,
    transform: "translate(1224 374)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1892",
    "data-name": "Rectangle 1892",
    width: 28,
    height: 10,
    rx: 5,
    transform: "translate(1244 387)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1890",
    "data-name": "Rectangle 1890",
    width: 21,
    height: 10,
    rx: 5,
    transform: "translate(1260 374)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1891",
    "data-name": "Rectangle 1891",
    width: 16,
    height: 10,
    rx: 5,
    transform: "translate(1254 348)",
    fill: "url(#linear-gradient-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomViews);
export default __webpack_public_path__ + "static/media/custom_views.5dbc3e6c4aa28e18f1e3e6f3c38aa342.svg";
export { ForwardRef as ReactComponent };